<template>
  <div class="deeplink-btn" v-show="show && useFunc">
    <span class="deeplink-btn-close" @click="handleHide">
      <icon type="iconic_cancel_pop"></icon>
    </span>
    <button class="deeplink-btn-wakeup" @click="handleWakeup">体验功能</button>

    <deeplink-modal
      ref="deeplink"
      @close="
        $collect.popupClick({ click: 'close', source: 'video', type: id })
      "
    ></deeplink-modal>
  </div>
</template>

<script>
import DeeplinkModal from '@/components/deeplink-modal';

export default {
  data() {
    return {
      show: false,
    };
  },

  props: {
    useFunc: String,
    id: [Number, String],
  },

  components: {
    DeeplinkModal,
  },

  methods: {
    handleHide() {
      this.show = false;
    },

    handleShow() {
      this.show = true;
    },

    handleWakeup() {
      this.$emit('wakeup');

      const link = this.useFunc;
      if (!link) return;

      if (link.indexOf('dk.u.wps.cn') !== -1) {
        this.$refs.deeplink.wakeup(link);
      } else {
        window.open(link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.deeplink-btn {
  position: relative;

  &-wakeup {
    cursor: pointer;
    width: 128px;
    height: 34px;
    line-height: 34px;
    background: #417ff9;
    border-radius: 17px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    border: none;
    outline: none;
  }

  &-close {
    cursor: pointer;
    position: absolute;
    top: -32px;
    right: -4px;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.3);
    @include flex-center();
    font-size: 16px;

    .icon {
      color: #fff;
      z-index: 1;
    }
    &:hover .icon {
      color: #f5222d;
    }
  }
}
</style>